import { defineMessages } from 'react-intl';

export const upgradeDialogMessages = defineMessages({
    headline: {
        id: 'upgrade-dialog.headline',
        defaultMessage:
            "It's time to upgrade! Avoid losing access to Calm Health.",
        description: 'Headline of the Buy-Up full-screen upgrade dialog',
    },
    headlinePastDeadline: {
        id: 'upgrade-dialog.headline_past_deadline',
        defaultMessage:
            "Upgrade today! Ensure you don't lose access to your Calm Health account.",
        description:
            'Headline of the Buy-Up full-screen upgrade dialog once the upgrade-by date has passed',
    },
    deadline: {
        id: 'upgrade-dialog.deadline',
        defaultMessage: 'Upgrade by:',
        description:
            'Deadline pod label in the Buy-Up full-screen upgrade dialog',
    },
    deadlineDate: {
        id: 'upgrade-dialog.deadline_date',
        defaultMessage: '{date}',
        description:
            'Deadline pod date in the Buy-Up full-screen upgrade dialog',
    },
    benefitContent: {
        id: 'upgrade-dialog.benefit_content',
        defaultMessage:
            'Get exclusive Disney content, our professional wellbeing video collection, and more.',
        description: 'First benefit row in the Buy-Up upgrade dialog',
    },
    benefitFriends: {
        id: 'upgrade-dialog.benefit_friends',
        defaultMessage:
            'Invite friends and family to join — directly from the app.',
        description: 'Second benefit row in the Buy-Up upgrade dialog',
    },
    benefitAll: {
        id: 'upgrade-dialog.benefit_all',
        defaultMessage:
            'Plus, access to all of your favorite Calm Health content and experiences.',
        description: 'Third benefit row in the Buy-Up upgrade dialog',
    },
    cta: {
        id: 'upgrade-dialog.cta',
        defaultMessage: 'Upgrade',
        description: 'Primary CTA button in the Buy-Up upgrade dialog',
    },
});

export default upgradeDialogMessages;
